import type { CreateVastProductInput, Item, VastProduct } from '@boodschappenlijst/shared';
import { api } from '../../lib/apiClient';

export interface OpLijstResultaat {
  toegevoegd: Item[];
  /** Namen die al openstonden en daarom zijn overgeslagen. */
  overgeslagen: string[];
}

export const vastApi = {
  list: () => api.get<{ producten: VastProduct[] }>('/vaste-producten'),
  create: (input: CreateVastProductInput) =>
    api.post<{ product: VastProduct }>('/vaste-producten', input),
  remove: (id: string) => api.del<{ ok: true }>(`/vaste-producten/${id}`),
  opLijst: (ids: string[]) => api.post<OpLijstResultaat>('/vaste-producten/op-lijst', { ids }),
};
